import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { faIndustry } from '@fortawesome/free-solid-svg-icons';
import { Col, Row } from 'reactstrap';
import moment from 'moment';

//Componentes
import MensagemInterna from '../../../views/CorreioInterno/MensagemInterna';
import InfoCard from '../../../components/InfoCard/InfoCard';

//Context
import { useAuth } from '../../../context/auth';
import { getSessionCookie, setSessionCookie } from '../../../helpers/cookies';

//API
import correioInterno_api from '../../../api/correioInterno_api';
import dashboard_api from '../../../api/dashboard_api';
import gerador_api from 'api/gerador_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from 'helpers/mascaras';

export default function Inicio() {
  const { session, setLoading, setupVariavel } = useAuth();

  const usuario = getSessionCookie();

  const [gerador, setGerador] = useState([])

  const [indicativosPGRS, setIndicativosPGRS] = useState(null);

  //State para verificar caso não existam mensagens não lidas, manter a tela em branco.
  const [mensagensExiste, setMensagensExiste] = useState(false);

  const [vencimentoCadastro, setVencimentoCadastro] = useState(null)

  const navigate = useNavigate();

  function loadMensagens() {
    setLoading(true);
    correioInterno_api.GetList().then(response => {
      setMensagensExiste(response.data.filter(x => x.status === "Mensagem Não Lida").length > 0);
    })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(_ => setLoading(false))

    if (session && session.acesso.modulo == "Gerador") {
      gerador_api.GetItem(0).then(response => {
        setGerador(response.data);
      }).catch(e => showMessage("Aviso", e.message, "error", null))
        .finally(f => setLoading(false));
    }
  }

  function loadIndicadoresPGRS() {
    setLoading(true);
    dashboard_api.GetIndicadoresGeradorPGRS().then(response => {
      setIndicativosPGRS(response.data);
    })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(_ => setLoading(false))
  }

  console.log(session)
  function handleVencimentoCadastro() {
    if (!!session.dataVencimento) {
      const dataVencimento = new Date(session.dataVencimento);
      const hoje = new Date();
      const diffTime = dataVencimento - hoje;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 0 && diffDays < 60) {
        setVencimentoCadastro(`Seu cadastro está a ${diffDays} dias do vencimento.`)
      } else {
        setVencimentoCadastro(null)
      }
    } else {
      setVencimentoCadastro(null);
    }
  }

  //Confere se tem mensagens pendentes de leitura
  useEffect(() => {
    if (session) {
      if (session.acesso.sigla == "GG")
        loadIndicadoresPGRS();

      if (session.acesso.sigla == "GG" || session.acesso.sigla == "DS" || session.acesso.sigla == "TR")
        handleVencimentoCadastro();
    }

    loadMensagens();
  }, [session]);

  return (
    <div className='mt-4'>
      {!!vencimentoCadastro &&
        <div className="alert alert-danger mx-4 my-2" role="alert">
          <h6>ATENÇÂO!!</h6>
          <p>{vencimentoCadastro}</p>
        </div>
      }
      {session && session.acesso.sigla == "GG" && <>
        {indicativosPGRS &&
          setupVariavel?.analisePGRS == true &&
          <>
            {indicativosPGRS.pgrsReprovados.length > 0 && <div className='mt-4'>
              <Row className='mx-4'>
                <h4 className="text-dark fw-normal">PGRS</h4>
              </Row>
              <Row className='mx-4'>
                {indicativosPGRS.pgrsReprovados.map((item, index) => (
                  <Col lg="4" md="6" sm="12" className='mb-3' key={index}>
                    <InfoCard
                      onClick={() => navigate("/admin/pgrs")}
                      icon={faIndustry}
                      title={item.descricaoPGRS}
                      specialSubTitle={"Acesse o PGRS, corrija as informações e aguarde uma nova análise"}
                      display={""}
                      link={"PGRS"}
                    />
                  </Col>
                ))}
              </Row>
            </div>}
            {indicativosPGRS.modalidadesSemCadastroPGRS.length > 0 &&
              <div className="mx-4 alert alert-danger" role="alert">
                <h6>ATENÇÂO!!</h6>
                <p>Obrigatório cadastrar PGRS para a(s) modalidade(s) {indicativosPGRS.modalidadesSemCadastroPGRS}.</p>
              </div>
            }
          </>
        }
      </>}

      {session && session.acesso.sigla == "GG" &&
        gerador?.localidades?.some(x => x.status == "Reprovado") &&
        <>
          <Row className='mx-4'>
            <h4 className="text-dark fw-normal">Análise do Cadastro</h4>
          </Row>
          <Row className='mx-4'>
            <Col lg="4" md="6" sm="12" className='mb-3' >
              <InfoCard
                onClick={() => navigate("/admin/meu-cadastro")}
                icon={faIndustry}
                title={"Cadastro Reprovado pelo Gestor"}
                specialSubTitle={"Clique aqui e acesse seu cadastro para corrigir as informações"}
                display={""}
                link={"meu-cadastro"}
              />
            </Col>
          </Row>
        </>
      }
      {session && mensagensExiste &&
        <MensagemInterna />
      }
    </div>
  )
}
